<template>
  <div class="productProcess">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.FabricReport.Product_Width') }}
    </div>
    <div class="productProcess-list" v-for="(item, index) in data" :key="index">
      <div class="dian1">
        <span>{{ $tc('lang.FabricReport.Dye_Lot') }}：</span>
        <a-input v-model="item.productwidth.widthDyelot"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.FabricReport.Roll_Number') }}：</span>
        <a-input v-model="item.productwidth.widthRollnumber"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.FabricReport.Full_Width') }}：</span>
        <a-input v-model="item.productwidth.widthFullwidth"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.FabricReport.Cuttable_Width') }}：</span>
        <a-input v-model="item.productwidth.widthCuttablewidth"></a-input>
      </div>
      <div class="desOfGoods-con">
        <span>{{ $tc('lang.FabricReport.Full_Width') }}：</span>
        <div class="img">
          <show-img
            :data="item.fullphoto"
            :otherData="{
              mediaName: '全门幅：',
              mediaType: 3,
              personId: '',
              orderId: '',
              reportId: '',
              mediaDesc: '',
            }"
            :id="id"
          ></show-img>
        </div>
      </div>
      <div class="desOfGoods-con">
        <span>{{ $tc('lang.FabricReport.Cuttable_Width') }}：</span>
        <div class="img">
          <show-img
            :data="item.cuttablephoto"
            :otherData="{
              mediaName: '可裁门幅：',
              mediaType: 3,
              personId: '',
              orderId: '',
              reportId: '',
              mediaDesc: '',
            }"
            :id="id"
          ></show-img>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';
export default {
  data() {
    return {
      data: [],
      id: this.$route.query.id,
    };
  },
  computed: {
    fabricDetails: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.report.fabricDetails),
        );
      },
    },
  },
  components: {
    showImg,
  },
  created() {
    this.getSelectDate();
  },
  methods: {
    //获取数据
    getSelectDate() {
      this.$http
        .post('/hzwmj/fabric-productwidth/seachFabricProductwidth', {
          lreportId: this.fabricDetails.freportId,
        })
        .then(data => {
          if (data) {
            data.data.forEach(item => {
              if (item.cuttablephoto == null) {
                item.cuttablephoto = [];
              }
              if (item.fullphoto == null) {
                item.fullphoto = [];
              }
            });
            this.data = data.data;
          } else {
            this.data = [];
          }
        })
        .catch(() => {
          this.data = [];
        });
    },
    //保存
    saveProductProcess(value) {
      let list = [];
      let imgList = [];
      let imgList1 = [];
      value.fullphoto.forEach(item => {
        imgList.push(item.id);
      });
      value.cuttablephoto.forEach(item => {
        imgList1.push(item.id);
      });
      const productwidth = value.productwidth;
      list.push({
        ...productwidth,
        modelType: '5',
        widthFullwidthphoto: imgList.join(','),
        widthCuttablewidthphoto: imgList1.join(','),
      });
      this.$http
        .post('/hzwmj/fabric-productwidth/saveOrUpdateFabricProductwidth', {
          data: list,
        })
        .then(data => {
          if (data) {
            this.$message.success('保存成功');
            this.getSelectDate();
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
    deleteImg(id) {
      this.$http
        .post('/hzwmj/inspect-defect/delectInspectDefect', {
          id: id,
        })
        .then(data => {
          if (data) {
            this.$message.success('删除成功');
            this.getSelectDate();
          } else {
            this.$message.error('删除失败');
          }
        })
        .catch(() => {
          this.$message.error('删除失败');
        });
    },
    cancel() {},
  },
};
</script>
<style lang="less">
.productProcess {
  .productProcess-list {
    margin-bottom: 20px;
  }
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .dian1 {
    margin-bottom: 10px;
    > span:nth-child(1) {
      width: 120px;
      padding-left: 20px;
      display: inline-block;
    }
    input {
      width: 150px;
    }
    .ant-radio-group {
      width: 220px;
    }
  }
}
</style>
